import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import DevPathIcon from '../../../ExperienceCatalog/Experience/OfferingType/DevelopmentPath/DevPathIcon';

interface Props {
  children?: React.ReactNode;
}

function ProgramSequenceLabel({ children }: Props) {
  return (
    <div className="relative w-min flex items-center rounded-2xl border-teal-700 text-teal-700 px-3 py-1 text-xs border">
      <span className="mr-2">
        <DevPathIcon />
      </span>
      <span className="mr-2">
        <T kind="Dev Path" />
      </span>
      {children}
    </div>
  );
}

export default observer(ProgramSequenceLabel);
